<template>
  <div>
    <section style="overflow-x: hidden" class="eventdetail" v-if="!hasEditing">
      <div class="heading_holder">
        <div
          class="left_side flex items-center"
          v-if="
            ['offline_one_2_one', 'online_one_2_one'].includes(
              eachEventInfo.extendedProps.course.course.courseStructure
                .course_type.type
            )
          "
        >
          <div class="cstm-img-holder flex flex-wrap items-center">
            <vs-tooltip
              :text="`${eachEventInfo.extendedProps.course.course.tutors[0].first_name} ${eachEventInfo.extendedProps.course.course.tutors[0].last_name}`"
              position="top"
              color="primary"
            >
              <img
                class="rounded-full shadow-md block"
                v-if="
                  eachEventInfo.extendedProps.course.course.tutors[0].picture
                "
                :src="
                  eachEventInfo.extendedProps.course.course.tutors[0].picture
                "
                height="40"
                width="40"
              />
              <span v-else class="material-icons" style="font-size: 40px"
                >account_circle</span
              >
            </vs-tooltip>

            <strong
              >{{
                eachEventInfo.extendedProps.course.course.tutors[0].first_name
              }}
              {{
                eachEventInfo.extendedProps.course.course.tutors[0].last_name
              }}</strong
            >
            <p class="w-full">
              Class Type:
              {{
                getCourseLabel(
                  eachEventInfo.extendedProps.course.course.courseStructure
                    .course_type.type
                )
              }}
            </p>
          </div>
        </div>
        <div v-else class="left_side flex items-center">
          <div
            class="cstm-img-holder"
            v-for="(eachStudent, index) in eachEventInfo.extendedProps.course
              .course.tutors"
            :key="index"
          >
            <vs-tooltip
              :text="`${eachStudent.first_name} ${eachStudent.last_name}`"
              position="top"
              color="primary"
            >
              <img
                class="rounded-full shadow-md block"
                v-if="eachStudent.picture"
                :src="eachStudent.picture"
                height="40"
                width="40"
              />
              <span v-else class="material-icons" style="font-size: 40px"
                >account_circle</span
              >
            </vs-tooltip>
          </div>
          <div class="header_details">
            <div
              style="cursor: pointer"
              class="inline-flex"
              @click="list_dropdown = !list_dropdown"
            >
              <p
                class="heading"
                v-if="
                  eachEventInfo.extendedProps.course.course.tutors.length > 2
                "
              >
                +{{ eachEventInfo.extendedProps.course.course.tutors.length }}
                Teachers
              </p>
              <p class="heading" v-else>
                {{ eachEventInfo.extendedProps.course.course.tutors.length }}
                Teachers
              </p>
              <span
                class="material-icons"
                :class="[list_dropdown ? 'rotate' : '']"
                >expand_more</span
              >
            </div>
            <div
              class="list_dropdown vertical_scrollbar"
              :class="[list_dropdown ? 'show' : '']"
            >
              <div
                class="each_data"
                v-for="(eachStudent, index) in eachEventInfo.extendedProps
                  .course.course.tutors"
                :key="index"
              >
                <img
                  class="rounded-full shadow-md block"
                  v-if="eachStudent.picture"
                  :src="eachStudent.picture"
                  height="36"
                  width="36"
                />
                <span v-else class="material-icons" style="font-size: 36px"
                  >account_circle</span
                >
                <span
                  >{{ eachStudent.first_name }}
                  {{ eachStudent.last_name }}</span
                >
              </div>
            </div>
            <p>
              Class Type:
              {{
                getCourseLabel(
                  eachEventInfo.extendedProps.course.course.courseStructure
                    .course_type.type
                )
              }}
            </p>
          </div>
        </div>

        <div class="right_side">
          <div class="inline-flex items-center pb-2 w-full">
            <span class="material-icons">date_range</span>
            <span class="pl-2">
              {{ $moment(eachEventInfo.start).format("ddd") }}
              {{ $moment(eachEventInfo.start).format("DD") }}
              {{ $moment(eachEventInfo.start).format("MMMM") }},
              {{ $moment(eachEventInfo.start).format("YYYY") }}
            </span>
          </div>
          <div class="inline-flex items-center w-full">
            <span class="material-icons">alarm</span>
            <span class="pl-2">
              {{
                eachEventInfo.extendedProps.course.schedule_from_time.slice(
                  0,
                  -3
                )
              }}
              -
              {{
                eachEventInfo.extendedProps.course.schedule_to_time.slice(0, -3)
              }}
            </span>
          </div>
        </div>
      </div>
      <div
        v-if="eachEventInfo.extendedProps.course.canceled_by"
        class="cancelled_alert"
      >
        Lesson was cancelled on
        {{
          eachEventInfo.extendedProps.course.canceled_at | moment("YYYY-MM-DD ")
        }}
        at
        {{
          eachEventInfo.extendedProps.course.canceled_at | moment("hh:mm a")
        }}
        by
        {{
          eachEventInfo.extendedProps.course.canceled_user_type == 1
            ? eachEventInfo.extendedProps.course.canceled_by_user.first_name +
              " " +
              eachEventInfo.extendedProps.course.canceled_by_user.last_name
            : eachEventInfo.extendedProps.course.canceled_user_type == 2
            ? eachEventInfo.extendedProps.course.canceled_by_client.first_name +
              " " +
              eachEventInfo.extendedProps.course.canceled_by_client.last_name
            : ""
        }}
      </div>
      <div style="padding: 15px 30px">
        <!-- tabs -->
        <ul class="cstm_tab_ul">
          <li :class="[info ? 'active' : '']" @click="viewTab('info')">Info</li>
          <li
            :class="[attendance ? 'active' : '']"
            @click="viewTab('attendance')"
          >
            Attendance
          </li>
          <li :class="[notes ? 'active' : '']" @click="viewTab('notes')">
            Notes
          </li>
        </ul>
      </div>

      <template v-if="info">
        <div class="details_holder">
          <img
            v-if="
              Object.keys(eachEventInfo.extendedProps.course.course.courseImage)
                .length > 0
            "
            :src="
              eachEventInfo.extendedProps.course.course.courseImage.file_path
            "
            alt="image"
          />
          <img
            v-else
            src="https://scoolio-files.s3.ap-south-1.amazonaws.com/Scoolio/Students+watching+webinar+on+computer.jpg"
            alt="course_image"
          />
          <div class="content">
            <span class="material-icons-outlined">collections_bookmark</span>
            <div class="pl-2">
              <h4 class="pb-2">{{ eachEventInfo.title }}</h4>
              <p class="pb-2">
                Subject:
                <b>{{
                  eachEventInfo.extendedProps.course.course.has_all_subject
                    ? "General"
                    : getAllSubject(
                        eachEventInfo.extendedProps.course.course.subjects
                      )
                }}</b>
              </p>
              <p>
                {{
                  eachEventInfo.extendedProps.description != null
                    ? eachEventInfo.extendedProps.description
                    : ""
                }}
              </p>
            </div>
          </div>
        </div>

        <div class="overall_detail_holder">
          <div class="each_data">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 21V19.4C6.43333 19.1333 6.825 18.8375 7.175 18.5125C7.525 18.1875 7.825 17.8417 8.075 17.475C8.325 17.1083 8.51667 16.7167 8.65 16.3C8.78333 15.8833 8.85 15.45 8.85 15C8.85 14.7833 8.8375 14.575 8.8125 14.375C8.7875 14.175 8.75 13.9667 8.7 13.75H6V12.25H7.95C7.3 11.35 6.85417 10.5542 6.6125 9.8625C6.37083 9.17083 6.25 8.46667 6.25 7.75C6.25 6.28333 6.75833 5.04167 7.775 4.025C8.79167 3.00833 10.0333 2.5 11.5 2.5C12.5833 2.5 13.5625 2.77083 14.4375 3.3125C15.3125 3.85417 15.9583 4.58333 16.375 5.5L15 6.075C14.7 5.44167 14.2292 4.9375 13.5875 4.5625C12.9458 4.1875 12.25 4 11.5 4C10.4667 4 9.58333 4.3625 8.85 5.0875C8.11667 5.8125 7.75 6.7 7.75 7.75C7.75 8.4 7.88333 9.0375 8.15 9.6625C8.41667 10.2875 8.95 11.15 9.75 12.25H14V13.75H10.225C10.275 13.9667 10.3083 14.1833 10.325 14.4C10.3417 14.6167 10.35 14.8167 10.35 15C10.35 15.8833 10.1583 16.7083 9.775 17.475C9.39167 18.2417 8.90833 18.9167 8.325 19.5H14C14.6333 19.5 15.1917 19.3333 15.675 19C16.1583 18.6667 16.5083 18.125 16.725 17.375L18.025 18.025C17.8083 19.0083 17.3042 19.75 16.5125 20.25C15.7208 20.75 14.8833 21 14 21H6Z"
                fill="#555262"
              />
            </svg>
            <div class="pl-2">
              <strong v-if="eachEventInfo.extendedProps.course.course.coursePaymentSetting.course_payment_type === 1">Free</strong>
              <strong v-else>£{{eachEventInfo.extendedProps.course.course.coursePaymentSetting.total_price}}</strong>
              <p>Price</p>
            </div>
          </div>
          <div class="each_data">
            <span class="material-icons-outlined">alarm</span>
            <div class="pl-2">
              <strong>{{ session_duration || "Not Available" }}</strong>
              <p>Session Duration</p>
            </div>
          </div>
          <div class="each_data">
            <span class="material-icons-outlined">event</span>
            <div class="pl-2">
              <strong>{{
                eachEventInfo.extendedProps.course.course.courseScheduleSetting
                  ? eachEventInfo.extendedProps.course.course
                      .courseScheduleSetting.no_of_sessions
                  : "Not Available"
              }}</strong>
              <p>Number of Sessions</p>
            </div>
          </div>
          <div class="each_data">
            <span class="material-icons-outlined">rotate_right</span>
            <div class="pl-2">
              <strong>{{ session_frequency || "Not Available" }} </strong>
              <p>Session Frequency</p>
            </div>
          </div>
          <div class="each_data">
            <span class="material-icons-outlined">insert_invitation</span>
            <div class="pl-2">
              <strong>{{
                course_start_date ? course_start_date : "Not Available"
              }}</strong>
              <p>Start Date</p>
            </div>
          </div>
          <div class="each_data">
            <span class="material-icons-outlined">insert_invitation</span>
            <div class="pl-2">
              <strong
                >{{ course_end_date ? course_end_date : "Not Available" }}
              </strong>
              <p>End Date</p>
            </div>
          </div>
        </div>

        <div class="footer_holder">
          <div>
            <div
              class="cstm-img-holder"
              v-for="(eachTutor, index) in eachEventInfo.extendedProps.course
                .course.enrolledStudents"
              :key="index"
            >
              <div>
                <vs-tooltip
                :text="`${eachTutor.first_name} ${eachTutor.last_name}`"
                position="top"
                color="primary"
              >
                <img
                  class="rounded-full shadow-md block"
                  v-if="eachTutor.picture"
                  :src="eachTutor.picture"
                  style="height: 30px !important; width: 30px !important"
                />
                <span v-else class="material-icons" style="font-size: 40px"
                  >account_circle</span
                >
              </vs-tooltip>
              </div>
            </div>
          </div>
          <div>
            <vs-button
              type="border"
              :disabled="eachEventInfo.extendedProps.course.canceled_by"
              color="danger"
              class="m-1"
              @click="cancelShedule"
              >Cancel</vs-button
            >
            <vs-button
              @click="checkRescheduleStatus"
              :disabled="
                checkReshedule ||
                !['offline_one_2_one', 'online_one_2_one'].includes(
                  eachEventInfo.extendedProps.course.course.courseStructure
                    .course_type.type
                )
              "
              >Reschedule</vs-button
            >
          </div>
        </div>
        <div v-if="resheduleCalender">
          <Reschedule
            :eachEventInfo="eachEventInfo"
            :resheduleCalender="resheduleCalender"
            :schedule_start_date="schedule_start_date"
            @closeCalendarAttendance="closeCalendarAttendance"
          />
        </div>
        <div
          class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup"
          v-if="cancelAlertPopup"
          :class="{ show: cancelAlertPopup }"
        >
          <div class="cstm-modal">
            <div class="header">
              <h3>Please Confirm</h3>
            </div>
            <div class="p-4 modal-content">
              Are you sure you want to cancel this schedule?
              <vs-row vs-justify="flex-end" class="mt-2">
                <vs-button
                  color="primary"
                  @click="cancelReschedule"
                  class="mr-3"
                  >Yes</vs-button
                >
                <vs-button
                  color="danger"
                  type="filled"
                  @click="cancelAlertPopup = false"
                  >No</vs-button
                >
              </vs-row>
            </div>
          </div>
        </div>
      </template>

      <template v-if="attendance">
        <CalenderAttendenceAction
          :eachEventInfo="eachEventInfo"
          @closeCalendarAttendance="closeCalendarAttendance"
        />
      </template>

      <template v-if="notes">
        <CalenderNotesAction
          :course_id="eachEventInfo.extendedProps.course.course.id"
          :schedule_id="eachEventInfo.extendedProps.course.id"
        />
      </template>
    </section>
  </div>
</template>

<script>
import Reschedule from '@/views/pages/schedule/resheduleComponent.vue'

import CalenderNotesAction from '@/views/pages/schedule/calenderACtionNotes.vue'
import CalenderAttendenceAction from '@/views/pages/schedule/calenderActionAttendence.vue'

// import { shortStudentListApi } from '@/api/student.js'
// import { enrollmentApi } from '@/api/course-builderapi'
import vSelect from 'vue-select'
import { updateRescheduleApi, courseMoreDetails } from '@/api/schedulerApi'
import { fetchDateRange, cancelSchedulerApi } from '@/api/calenderActions'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import Editor from '@tinymce/tinymce-vue'

export default {
  components: {
    vSelect,
    flatPickr,
    editor: Editor,
    CalenderNotesAction,
    CalenderAttendenceAction,
    Reschedule
  },
  async created () {},

  mounted () {
    console.log(this.tabType)
    this.fetchCourseDetails()
    this.fetchDateRange()
    let duration = []
    let frequency = []
    if (
      this.eachEventInfo.extendedProps.course &&
      this.eachEventInfo.extendedProps.course.course.courseScheduleSetting !==
        null
    ) {
      if (
        this.eachEventInfo.extendedProps.course.course.courseScheduleSetting
          .session_duration_id !== null
      ) {
        duration = this.durationsArray.filter(
          (ele) => ele.id ===
            this.eachEventInfo.extendedProps.course.course.courseScheduleSetting
              .session_duration_id
        )
      }
      if (
        this.eachEventInfo.extendedProps.course.course.courseScheduleSetting
          .session_frequency_id !== null
      ) {
        frequency = this.frequencyArray.filter(
          (ele) => ele.id ===
            this.eachEventInfo.extendedProps.course.course.courseScheduleSetting
              .session_frequency_id
        )
      }

      this.session_frequency =
        duration.length > 0 ? `${frequency[0].name}` : ''
      this.session_duration = duration.length > 0 ? `${duration[0].name} ` : ''
    }

    this.datedifference = this.validateTodayDate(
      new Date(),
      this.eachEventInfo.start
    )
    //

    console.log(this.eachEventInfo.extendedProps)
  },
  data () {
    return {
      cancelAlertPopup: false,
      schedule_start_date: null,
      course_start_date: '',
      course_end_date: '',
      customer_id: localStorage.getItem('customer_id'),
      selectedBtnOption: {
        title: 'Save'
      },
      btn_options: [
        {
          title: 'Save & Submit'
        }
      ],
      cstmBtnDrop: false,

      session_frequency: null,
      session_duration: null,
      info: true,
      attendance: false,
      notes: false,
      list_dropdown: false,

      billing_radio: '2',
      price: '',

      email_notes: [],

      skype: false,
      zoom: false,
      iconSkypeActive: false,
      iconZoomActive: false,
      skype_url: '',
      zoom_url: '',
      enrolledSelectedId: [],
      studentList: [],
      studentUnenrolledList: [],
      datedifference: 0,
      hasEditing: false,
      course_class_type_list: [
        {
          value: 'self_based',
          name: 'Self Paced Course'
        },
        {
          value: 'online_one_2_one',
          name: 'Online Individual Course'
        },
        {
          value: 'online_one_2_many',
          name: 'Online Group Course'
        },
        {
          value: 'offline_one_2_one',
          name: 'In Person Individual Course'
        },
        {
          value: 'offline_one_2_many',
          name: 'In Person Group Course'
        }
      ],
      configStartDate: {
        dateFormat: 'Y-m-d'
      },
      resheduleCalender: false
    }
  },
  props: {
    eachEventInfo: {
      type: Object,
      required: true
    },
    name: {},
    tabType: {}
  },
  computed: {
    checkReshedule () {
      if (this.schoolAdmin) {
        return false
      } else if (this.$moment().diff(this.eachEventInfo.start, 'minutes') <= 0) return false
      else return true
    },
    checkingEdit () {
      return (
        this.eachEventInfo.extendedProps.course.course.course_setting
          .reschedule_allowed &&
        !this.hasEditing &&
        this.datedifference < 0 &&
        this.eachEventInfo.extendedProps.course.already_reschedule_count <
          this.eachEventInfo.extendedProps.course.course.course_setting
            .reschedule_count
      )
    },
    checkingTeacher () {
      if (this.name === 'Teachers') {
        return true
      }
      return false
    },
    checkingOne2ManyCourseType () {
      if (
        this.eachEventInfo.extendedProps.course.course_setting
          .course_class_type === 'online_one_2_many' ||
        this.eachEventInfo.extendedProps.course.course_setting
          .course_class_type === 'offline_one_2_many'
      ) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    cancelAlert () {
      this.cancelAlertPopup = true
      // this.$vs.dialog({
      //   type: 'confirm',
      //   color: 'danger',
      //   title: 'Please Confirm',
      //   text: 'Are you sure you want to cancel this schedule?',
      //   accept: this.cancelReschedule
      // })
    },
    async cancelReschedule () {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const payload = {
          schedule_date: this.$moment(
            this.eachEventInfo.extendedProps.course.schedule_date
          ).format('YYYY-MM-DD'),
          schedule_id: this.eachEventInfo.extendedProps.course.id,
          course_id: this.eachEventInfo.extendedProps.course.course_id,
          group_id: this.eachEventInfo.extendedProps.course.group_id
        }
        await cancelSchedulerApi(customer_id, payload)

        this.showSuccessMessage(
          'Success',
          'Lesson cancelled successfully',
          'success'
        )
        this.$emit('editedSchedule', true)
      } catch (error) {
        console.warn(error)
        this.showSuccessMessage('Error', 'Something went wrong', 'danger')
      }
    },
    async cancelShedule () {
      if (
        ['offline_one_2_one', 'online_one_2_one'].includes(
          this.eachEventInfo.extendedProps.course.course.courseStructure
            .course_type.type
        )
      ) {
        if (
          this.$moment().diff(
            this.eachEventInfo.extendedProps.course.schedule_date,
            'minutes'
          ) >= 0
        ) {
          this.showSuccessMessage(
            'Warning',
            'Previous schedule can not be cancelled',
            'warning'
          )
        } else {
          this.cancelAlert()
        }
      } else {
        this.showSuccessMessage(
          'Warning',
          'Group lessons can\'t be cancelled',
          'warning'
        )
      }
    },
    checkRescheduleStatus () {
      if (this.remainingReschedule === 0) {
        this.showSuccessMessage(
          'Error',
          'You have reached the maximum number of reschedules for this course',
          'danger'
        )
      } else {
        this.resheduleCalender = true
      }
    },
    async fetchDateRange () {
      const payload = {
        course_id: this.eachEventInfo.extendedProps.course.course_id,
        unique_id: this.eachEventInfo.extendedProps.course.unique_id
      }
      const { data } = await fetchDateRange(this.customer_id, payload)
      this.course_start_date = data.data.course_dateRange.start_date
      this.course_end_date = data.data.course_dateRange.end_date
    },
    closeCalendarAttendance () {
      this.$emit('editedSchedule', true)
    },
    deletedIndex (deleteIndex) {
      this.filesInfo.splice(deleteIndex, 1)
      this.createPayload.files = null
    },
    getIdFile (obj) {
      console.log(obj)
      this.createPayload.files.push(obj)
    },
    async fetchCourseDetails () {
      this.customer_id =
        this.eachEventInfo.extendedProps.course.platform_customer_id
      const payload = {
        course_id: this.eachEventInfo.extendedProps.course.course_id
      }
      const { data } = await courseMoreDetails(payload, this.customer_id)
      this.eachEventInfo.extendedProps.course.course = data.data.course
    },

    getAllSubject (subjects) {
      let subjectArray = ''
      subjectArray = subjects.map((e) => {
        if (e.subject_name) {
          return e.subject_name
        }
      })
      subjectArray = subjectArray.join(', ')
      return subjectArray
    },
    viewTab (type) {
      if (type === 'info') {
        this.info = true
        this.attendance = false
        this.notes = false
      } else if (type === 'attendance') {
        this.info = false
        this.attendance = true
        this.notes = false
      } else if (type === 'notes') {
        this.info = false
        this.attendance = false
        this.notes = true
      }
    },

    icon (type) {
      if (type === 'skype') {
        this.skype = true
        this.zoom = false
        this.iconSkypeActive = true
        this.iconZoomActive = false
      } else {
        this.skype = false
        this.zoom = true
        this.iconSkypeActive = false
        this.iconZoomActive = true
      }
    },
    async updateUrl () {
      try {
        this.$vs.loading({
          text: 'Updating'
        })
        const payload = {
          skype_link: this.skype_url,
          zoom_link: this.zoom_url,
          schedule_date: this.$moment(
            this.eachEventInfo.extendedProps.course.schedule_date
          ).format('YYYY-MM-DD')
        }
        if (
          this.eachEventInfo.extendedProps.course.course.course_setting
            .course_class_type === 'online_one_2_one'
        ) {
          payload.client_user_id =
            this.eachEventInfo.extendedProps.course.course.enrolledStudents[0].client_user_id
        }
        payload.user_id = this.eachEventInfo.extendedProps.course.teacher.id

        // const customer = localStorage.getItem('customer_id')
        const { data } = await updateRescheduleApi(
          this.eachEventInfo.extendedProps.course.course.id,
          this.customer_id,
          payload
        )
        if (data.message) {
          this.$emit('editedSchedule', 'Link')
        }
      } catch (error) {
        console.warn(error)
      } finally {
        this.$vs.loading.close()
      }
    },
    removingEnrolled (studentArray) {
      const enrolledStudentId =
        this.eachEventInfo.extendedProps.course.course.enrolledStudents.map(
          (ele) => {
            return ele.client_user_id
          }
        )

      this.studentUnenrolledList = studentArray.filter((eachStudent) => {
        return !enrolledStudentId.includes(eachStudent.client_users_id)
      })
    },
    getCourseLabel (coursetype) {
      const index = this.course_class_type_list.findIndex((ele) => {
        return ele.value === coursetype
      })
      if (index) {
        return this.course_class_type_list[index].name
      }
      return coursetype
    },
    getContrast (hexcolor) {
      //   //
      hexcolor = hexcolor.replace('#', '')
      const r = parseInt(hexcolor.substr(0, 2), 16)
      const g = parseInt(hexcolor.substr(2, 2), 16)
      const b = parseInt(hexcolor.substr(4, 2), 16)
      const yiq = (r * 299 + g * 587 + b * 114) / 1000
      return yiq >= 128 ? '#000000' : '#ffffff'
    },
    getCourseTypeName (typeId) {
      let courseTypeName = ''
      switch (typeId) {
      case 1:
        courseTypeName = 'Open'
        break
      case 2:
        courseTypeName = 'Free'
        break
      case 3:
        courseTypeName = 'Paid'
        break
      case 4:
        courseTypeName = 'Recurring'
        break
      default:
        courseTypeName = 'Others'
      }
      return courseTypeName
    },
    cancelEditingComponent () {
      this.hasEditing = false
    },
    updateRescheduleEmit (updatedObject) {
      this.$emit('editedSchedule', updatedObject)
    },
    async saveEnrollment () {
      if (this.enrolledSelectedId.length) {
        // const customer_id = localStorage.getItem('customer_id')
        const paylaod = {
          course_id: this.eachEventInfo.extendedProps.course.course.id,
          teacher_id: this.eachEventInfo.extendedProps.userId,
          session_frequency_month_day: [],
          session_frequency_week_day: [],
          clientUser: this.enrolledSelectedId,
          course_start_date:
            this.eachEventInfo.extendedProps.course.course_setting
              .course_start_date,
          course_start_time:
            this.eachEventInfo.extendedProps.course.course_setting
              .course_start_time
        }

        await enrollmentApi(paylaod, this.customer_id)
        this.showSuccessMessage(
          'Success',
          'Student Enrolled Successfully',
          'success'
        )

        this.$emit('enrolledUser', false)
      } else {
        this.showSuccessMessage('Error', 'No Student Selected', 'danger')
      }
    }
  }
}
</script>

<style>
.cancelled_alert {
  background: rgba(241, 93, 95, 0.3);
  color: rgb(241, 93, 95);
  font-weight: 600;
  text-align: center;
  padding: 10px 0;
}
.color-holder {
  width: 100%;
  height: 30px;
  border-radius: 5px;
}
.vs-tooltip {
  z-index: 100000;
}
.meetup-header {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  position: relative;
}
.meetup_inner_holder {
  width: calc(100% - 38px);
  display: flex;
  /* flex-wrap: wrap; */
}
.editable_holder {
  position: absolute;
  top: 0;
  right: 0;
}
.meetup-header .meetup-day {
  border-right: 1px solid #d8d6de;
  padding-right: 1.3rem;
  margin-right: 1.3rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.meetup-header .card-title {
  width: 60%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
  font-size: 1.285rem;
  display: inline-block;
}
.inform-meetup-holder {
  display: flex;
  align-items: center;
  margin: 20px 0;
}
.inform-meetup-holder .badge-avatar {
  margin-right: 14px;
}
.status_main_holder {
  position: relative;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(65, 207, 221, 0.12);
  border-radius: 5px;
  margin: 0 15px 10px 0;
  cursor: pointer;
}
.status_main_holder.active {
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.2);
  transform: scale(1.12);
}
.status_main_holder .status_icon_holder {
  position: absolute;
  top: -8px;
  right: -8px;
}
.status_main_holder .status_icon_holder .check {
  color: green;
  font-size: 20px;
}
.status_main_holder .status_icon_holder .error {
  color: orange;
  font-size: 20px;
}
</style>
